module.exports = __webpack_public_path__ + "static/media/Emily02_thumb_hover.b1d48607.png";